export const roleInit = {
  access: {
    title: 'Truy cập',
    key: 'access',
    childs: [
      {
        title: 'App nội bộ',
        key: 'P72'
      },
      {
        title: 'App cộng đồng',
        key: 'P73'
      }
    ]
  },
  internal_app_r: {
    title: 'App nội bộ thuê',
    key: 'internal_app_r',
    childs: [
      {
        title: 'Đăng tin',
        key: 'P1',
        childs: [
          { title: 'Ảnh', key: 'P1.1' },
          { title: 'Video', key: 'P1.2' },
          { title: 'Ảnh 360', key: 'P1.3' }
        ]
      },
      { title: 'Đăng yêu cầu', key: 'P2' },
      { title: 'Xem tin theo dạng bảng', key: 'P3' },
      { title: 'Thả tim - Lưu trữ tin', key: 'P4' },
      { title: 'Phân quyền tin đăng', key: 'P5' },
      { title: 'Phân quyền yêu cầu', key: 'P6' },
      { title: 'Cập nhật hiện trạng tin đăng', key: 'P7' },
      { title: 'Cập nhật hiện trạng yêu cầu', key: 'P8' },
      { title: 'Sửa tin đăng', key: 'P9' },
      { title: 'Sửa yêu cầu', key: 'P10' },
      {
        title: 'Call trong tin đăng',
        key: 'P11',
        childs: [
          { title: 'Gọi cho giám đốc sàn', key: 'P11.1' },
          { title: 'Gọi cho quản lý sản phẩm', key: 'P11.2' },
          { title: 'Gọi cho người đăng tin', key: 'P11.3' },
          { title: 'Gọi cho khách hàng', key: 'P11.4' }
        ]
      },
      {
        title: 'Call trong yêu cầu',
        key: 'P12',
        childs: [
          { title: 'Gọi cho giám đốc sàn', key: 'P12.1' },
          { title: 'Gọi cho quản lý sản phẩm', key: 'P12.2' },
          { title: 'Gọi cho người đăng tin', key: 'P12.3' },
          { title: 'Gọi cho khách hàng', key: 'P12.4' }
        ]
      },
      { title: 'Copy tin đăng', key: 'P13' },
      { title: 'Copy yêu cầu', key: 'P14' },
      { title: 'Note tin đăng', key: 'P15' },
      { title: 'Note yêu cầu', key: 'P16' },
      { title: 'Book tin đăng', key: 'P17' },
      { title: 'Book yêu cầu', key: 'P18' },
      {
        title: 'View tin đăng',
        key: 'P21',
        childs: [
          { title: 'Ảnh', key: 'P21.1' },
          { title: 'Var 360', key: 'P21.2' },
          { title: 'Video', key: 'P21.3' },
          { title: 'Bản đồ', key: 'P21.4' },
          { title: 'Địa chỉ', key: 'P21.5' },
          { title: 'Giá', key: 'P21.6' },
          { title: 'Phí môi giới', key: 'P21.7' },
          { title: 'Mã tin', key: 'P21.8' },
          { title: 'Tên dự án', key: 'P21.9' },
          { title: 'Mã căn hộ', key: 'P21.10' },
          { title: 'Số địa chỉ', key: 'P21.11' },
          { title: 'Tòa khu', key: 'P21.12' },
          { title: 'Tầng/Dãy', key: 'P21.13' },
          { title: 'Số căn', key: 'P21.14' },
          { title: 'Diện tích (m2)', key: 'P21.15' },
          { title: 'Mặt tiền (m)', key: 'P21.16' },
          { title: 'Số tầng', key: 'P21.17' },
          { title: 'Số phòng ngủ', key: 'P21.18' },
          { title: 'Số WC', key: 'P21.19' },
          { title: 'Hướng', key: 'P21.20' },
          { title: 'Vị trí', key: 'P21.21' },
          { title: 'Giấy tờ pháp lý', key: 'P21.22' },
          { title: 'Phí giao dịch', key: 'P21.23' },
          { title: 'Nội thất', key: 'P21.24' },
          { title: 'Người đăng tin', key: 'P21.25' },
          { title: 'Ngày giờ đăng', key: 'P21.26' },
          { title: 'Mô tả', key: 'P21.27' },
          { title: 'Note', key: 'P21.28' },
          { title: 'Lịch sử', key: 'P21.29' }
        ]
      },
      {
        title: 'View tin yêu cầu',
        key: 'P22',
        childs: [
          { title: 'Mã yêu cầu', key: 'P22.1' },
          { title: 'Tỉnh/Thành phố', key: 'P22.2' },
          { title: 'Quận/huyện', key: 'P22.3' },
          { title: 'Phường/Xã/Thị trấn', key: 'P22.4' },
          { title: 'Đường phố', key: 'P22.5' },
          { title: 'Loại BĐS', key: 'P22.6' },
          { title: 'Loại hình BĐS', key: 'P22.7' },
          { title: 'Số phòng ngủ', key: 'P22.8' },
          { title: 'Diện tích (m2)', key: 'P22.9' },
          { title: 'Mặt tiền (m)', key: 'P22.10' },
          { title: 'Số tầng', key: 'P22.11' },
          { title: 'Hướng', key: 'P22.12' },
          { title: 'Vị trí', key: 'P22.13' },
          { title: 'Tài chính', key: 'P22.14' },
          { title: 'Người đăng tin', key: 'P22.15' },
          { title: 'Ngày giờ đăng', key: 'P22.16' },
          { title: 'Thông tin người yêu cầu', key: 'P22.17' },
          { title: 'Mô tả', key: 'P22.18' },
          { title: 'Note', key: 'P22.19' },
          { title: 'Lịch sử', key: 'P22.20' }
        ]
      }
    ]
  },

  internal_app_s: {
    title: 'App nội bộ bán',
    key: 'internal_app_s',
    childs: [
      {
        title: 'Đăng tin',
        key: 'PR1',
        childs: [
          { title: 'Ảnh', key: 'PR1.1' },
          { title: 'Video', key: 'PR1.2' },
          { title: 'Ảnh 360', key: 'PR1.3' }
        ]
      },
      { title: 'Đăng yêu cầu', key: 'PR2' },
      { title: 'Xem tin theo dạng bảng', key: 'PR3' },
      { title: 'Thả tim - Lưu trữ tin', key: 'PR4' },
      { title: 'Phân quyền tin đăng', key: 'PR5' },
      { title: 'Phân quyền yêu cầu', key: 'PR6' },
      { title: 'Cập nhật hiện trạng tin đăng', key: 'PR7' },
      { title: 'Cập nhật hiện trạng yêu cầu', key: 'PR8' },
      { title: 'Sửa tin đăng', key: 'PR9' },
      { title: 'Sửa yêu cầu', key: 'PR10' },
      {
        title: 'Call trong tin đăng',
        key: 'PR11',
        childs: [
          { title: 'Gọi cho giám đốc sàn', key: 'PR11.1' },
          { title: 'Gọi cho quản lý sản phẩm', key: 'PR11.2' },
          { title: 'Gọi cho người đăng tin', key: 'PR11.3' },
          { title: 'Gọi cho khách hàng', key: 'PR11.4' }
        ]
      },
      {
        title: 'Call trong yêu cầu',
        key: 'PR12',
        childs: [
          { title: 'Gọi cho giám đốc sàn', key: 'PR12.1' },
          { title: 'Gọi cho quản lý sản phẩm', key: 'PR12.2' },
          { title: 'Gọi cho người đăng tin', key: 'PR12.3' },
          { title: 'Gọi cho khách hàng', key: 'PR12.4' }
        ]
      },
      { title: 'Copy tin đăng', key: 'PR13' },
      { title: 'Copy yêu cầu', key: 'PR14' },
      { title: 'Note tin đăng', key: 'PR15' },
      { title: 'Note yêu cầu', key: 'PR16' },
      { title: 'Book tin đăng', key: 'PR17' },
      { title: 'Book yêu cầu', key: 'PR18' },
      {
        title: 'View tin đăng',
        key: 'PR21',
        childs: [
          { title: 'Ảnh', key: 'PR21.1' },
          { title: 'Var 360', key: 'PR21.2' },
          { title: 'Video', key: 'PR21.3' },
          { title: 'Bản đồ', key: 'PR21.4' },
          { title: 'Địa chỉ', key: 'PR21.5' },
          { title: 'Giá', key: 'PR21.6' },
          { title: 'Phí môi giới', key: 'PR21.7' },
          { title: 'Mã tin', key: 'PR21.8' },
          { title: 'Tên dự án', key: 'PR21.9' },
          { title: 'Mã căn hộ', key: 'PR21.10' },
          { title: 'Số địa chỉ', key: 'PR21.11' },
          { title: 'Tòa khu', key: 'PR21.12' },
          { title: 'Tầng/Dãy', key: 'PR21.13' },
          { title: 'Số căn', key: 'PR21.14' },
          { title: 'Diện tích (m2)', key: 'PR21.15' },
          { title: 'Mặt tiền (m)', key: 'PR21.16' },
          { title: 'Số tầng', key: 'PR21.17' },
          { title: 'Số phòng ngủ', key: 'PR21.18' },
          { title: 'Số WC', key: 'PR21.19' },
          { title: 'Hướng', key: 'PR21.20' },
          { title: 'Vị trí', key: 'PR21.21' },
          { title: 'Giấy tờ pháp lý', key: 'PR21.22' },
          { title: 'Phí giao dịch', key: 'PR21.23' },
          { title: 'Nội thất', key: 'PR21.24' },
          { title: 'Người đăng tin', key: 'PR21.25' },
          { title: 'Ngày giờ đăng', key: 'PR21.26' },
          { title: 'Mô tả', key: 'PR21.27' },
          { title: 'Note', key: 'PR21.28' },
          { title: 'Lịch sử', key: 'PR21.29' }
        ]
      },
      {
        title: 'View tin yêu cầu',
        key: 'PR22',
        childs: [
          { title: 'Mã yêu cầu', key: 'PR22.1' },
          { title: 'Tỉnh/Thành phố', key: 'PR22.2' },
          { title: 'Quận/huyện', key: 'PR22.3' },
          { title: 'Phường/Xã/Thị trấn', key: 'PR22.4' },
          { title: 'Đường phố', key: 'PR22.5' },
          { title: 'Loại BĐS', key: 'PR22.6' },
          { title: 'Loại hình BĐS', key: 'PR22.7' },
          { title: 'Số phòng ngủ', key: 'PR22.8' },
          { title: 'Diện tích (m2)', key: 'PR22.9' },
          { title: 'Mặt tiền (m)', key: 'PR22.10' },
          { title: 'Số tầng', key: 'PR22.11' },
          { title: 'Hướng', key: 'PR22.12' },
          { title: 'Vị trí', key: 'PR22.13' },
          { title: 'Tài chính', key: 'PR22.14' },
          { title: 'Người đăng tin', key: 'PR22.15' },
          { title: 'Ngày giờ đăng', key: 'PR22.16' },
          { title: 'Thông tin người yêu cầu', key: 'PR22.17' },
          { title: 'Mô tả', key: 'PR22.18' },
          { title: 'Note', key: 'PR22.19' },
          { title: 'Lịch sử', key: 'PR22.20' }
        ]
      }
    ]
  },

  function: {
    title: 'Chức năng nội bộ',
    key: 'public_app',
    childs: [
      {
        title: 'Tiện ích',
        key: 'P70',
        childs: [
          {
            title: 'Bất động sản Bán',
            key: 'P70.1'
          },
          {
            title: 'Bất động sản Cho thuê',
            key: 'P70.2'
          },
          {
            title: 'Báo cáo',
            key: 'P70.3'
          },
          {
            title: 'Kho hàng',
            key: 'P70.4'
          },
          {
            title: 'Cộng đồng',
            key: 'P70.5'
          },
          {
            title: 'Dự án',
            key: 'P70.6'
          },
          {
            title: 'Yêu cầu',
            key: 'P70.7'
          },
          {
            title: 'Kho của tôi',
            key: 'P70.8'
          },
          {
            title: 'Phân yêu cầu',
            key: 'P70.9'
          }
        ]
      },
      {
        title: 'Quản lý sàn',
        key: 'P71',
        childs: [
          { title: 'Báo cáo nhân sự', key: 'P71.1' },
          { title: 'Báo cáo hoạt động nhân sự', key: 'P71.2' },
          { title: 'Báo cáo vận hành', key: 'P71.3' }
        ]
      }
    ]
  },
  public_app: {
    title: 'App cộng đồng',
    key: 'public_app',
    childs: [
      {
        title: 'Đăng tin',
        key: 'P23',
        childs: [
          {
            title: 'Ảnh',
            key: 'P23.1'
          },
          {
            title: 'Video',
            key: 'P23.2'
          },
          {
            title: 'Ảnh 360',
            key: 'P23.3'
          }
        ]
      },
      {
        title: 'Đăng yêu cầu',
        key: 'P24'
      },
      {
        title: 'Xem tin theo dạng bảng tin/yêu cầu',
        key: 'P25'
      },
      {
        title: 'Thả tim - Lưu trữ tin',
        key: 'P26'
      },
      {
        title: 'Chia sẻ - Copy',
        key: 'P27'
      },
      {
        title: 'Call',
        key: 'P28',
        childs: [
          {
            title: 'Gọi cho giám đốc sàn',
            key: 'P28.1'
          },
          {
            title: 'Gọi cho quản lý sản phẩm',
            key: 'P28.2'
          },
          {
            title: 'Gọi cho người đăng tin',
            key: 'P28.3'
          },
          {
            title: 'Gọi cho khách hàng',
            key: 'P28.4'
          }
        ]
      },
      {
        title: 'Sao chép liên kết',
        key: 'P29'
      },
      {
        title: 'Báo cáo vi phạm',
        key: 'P30'
      },
      {
        title: 'Ẩn tin',
        key: 'P31'
      },
      {
        title: 'Sửa tin',
        key: 'P32'
      },
      {
        title: 'Xóa tin',
        key: 'P33'
      },
      {
        title: 'Cập nhật hiện trạng',
        key: 'P34'
      },
      {
        title: 'Book tin đăng',
        key: 'P90'
      },
      {
        title: 'Book yêu cầu',
        key: 'P91'
      },
      {
        title: 'View tin đăng/yêu cầu',
        key: 'P35',
        childs: [
          {
            title: 'Ảnh',
            key: 'P35.1'
          },
          {
            title: 'Video',
            key: 'P35.2'
          },
          {
            title: 'Var 360',
            key: 'P35.3'
          },
          {
            title: 'Bản đồ',
            key: 'P35.4'
          },
          {
            title: 'Tiêu đề',
            key: 'P35.5'
          },
          {
            title: 'Địa chỉ',
            key: 'P35.6'
          },
          {
            title: 'Giá/Tài chính',
            key: 'P35.7'
          },
          {
            title: 'Phí môi giới',
            key: 'P35.8'
          },
          {
            title: 'Mã tin',
            key: 'P35.9'
          },
          {
            title: 'Tên dự án',
            key: 'P35.10'
          },
          {
            title: 'Diện tích (m2)',
            key: 'P35.11'
          },
          {
            title: 'Mặt tiền (m)',
            key: 'P35.12'
          },
          {
            title: 'Số tầng',
            key: 'P35.13'
          },
          {
            title: 'Số phòng ngủ',
            key: 'P35.14'
          },
          {
            title: 'Số WC',
            key: 'P35.15'
          },
          {
            title: 'Hướng',
            key: 'P35.16'
          },
          {
            title: 'Vị trí',
            key: 'P35.17'
          },
          {
            title: 'Nội thất',
            key: 'P35.18'
          },
          {
            title: 'Giấy tờ pháp lý',
            key: 'P35.19'
          },
          {
            title: 'Phí giao dịch',
            key: 'P35.20'
          },
          {
            title: 'Người đăng tin',
            key: 'P35.21'
          },
          {
            title: 'Ngày giờ đăng',
            key: 'P35.22'
          },
          {
            title: 'Mô tả',
            key: 'P35.23'
          },
          {
            title: 'Lịch sử',
            key: 'P35.24'
          }
        ]
      }
    ]
  },
  notification_internal: {
    title: 'Thông báo nội bộ',
    key: 'P74',
    childs: [
      { title: 'Thông báo tài khoản', key: 'P74.1' },
      { title: 'Thông báo tin', key: 'P74.2' },
      { title: 'Thông báo sửa tin', key: 'P74.3' },
      { title: 'Thông báo book tin', key: 'P74.4' },
      { title: 'Thông báo yêu cầu', key: 'P74.5' },
      { title: 'Thông báo sửa yêu cầu', key: 'P74.6' },
      { title: 'Thông báo book yêu cầu', key: 'P74.7' }
    ]
  },
  notification_community: {
    title: 'Thông báo cộng đồng',
    key: 'P75',
    childs: [
      { title: 'Thông báo tài khoản', key: 'P75.1' },
      { title: 'Thông báo tin', key: 'P75.2' },
      { title: 'Thông báo sửa tin', key: 'P75.3' },
      { title: 'Thông báo book tin', key: 'P75.4' },
      { title: 'Thông báo báo cáo tin', key: 'P75.5' },
      { title: 'Thông báo ẩn tin', key: 'P75.6' },
      { title: 'Thông báo xóa tin', key: 'P75.7' },
      { title: 'Thông báo nạp tiền', key: 'P75.8' },
      { title: 'Thông báo thanh toán gia hạn', key: 'P75.9' },
      { title: 'Thông báo sắp hết hạn cộng đồng', key: 'P75.10' }
    ]
  },

  cms: {
    title: 'CMS',
    key: 'cms',
    childs: [
      {
        title: 'Dashboard',
        key: 'P35'
      },
      {
        title: 'Quản lý vận hành hệ thống',
        key: 'P36',
        childs: [
          {
            title: 'Export',
            key: 'P36.1'
          }
        ]
      },
      {
        title: 'Quản lý tin nội bộ',
        key: 'P37',
        childs: [
          { title: 'Đăng tin', key: 'P37.1' },
          { title: 'Import', key: 'P37.2' },
          // { title: 'Publish', key: 'P37.3' },
          { title: 'Chọn quản lý tin', key: 'P37.3' },
          { title: 'Sửa tin', key: 'P37.4' },
          { title: 'Lịch sử', key: 'P37.5' },
          { title: 'Note', key: 'P37.6' },
          // { title: 'Danh sách xem nhà', key: 'P37.7' },
          // { title: 'Danh sách đấu giá', key: 'P37.8' },
          { title: 'Xóa tin', key: 'P37.9' },
          { title: 'Export', key: 'P37.10' }
        ]
      },
      {
        title: 'Quản lý yêu cầu nội bộ',
        key: 'P38',
        childs: [
          { title: 'Đăng yêu cầu', key: 'P38.1' },
          { title: 'Import', key: 'P38.2' },
          { title: 'Sửa yêu cầu', key: 'P38.3' },
          { title: 'Xóa yêu cầu', key: 'P38.4' },
          { title: 'Phân quyền yêu cầu', key: 'P38.5' },
          { title: 'Lịch sử', key: 'P38.6' },
          { title: 'Note', key: 'P38.7' },
          { title: 'Export', key: 'P38.8' }
        ]
      },
      {
        title: 'Quản lý tin/yêu cầu cộng đồng',
        key: 'P39',
        childs: [
          { title: 'Import', key: 'P39.1' },
          { title: 'Thêm mới', key: 'P39.2' },
          { title: 'Sửa', key: 'P39.3' },
          { title: 'Lịch sử', key: 'P39.4' },
          { title: 'Xoá', key: 'P39.5' },
          { title: 'Export', key: 'P39.6' }
        ]
      },
      {
        title: 'Quản lý quyền',
        key: 'P40',
        childs: [
          { title: 'Thêm mới', key: 'P40.1' },
          { title: 'Chỉnh sửa', key: 'P40.2' },
          { title: 'Xóa', key: 'P40.4' },
          { title: 'Active/Inactive', key: 'P40.3' }
        ]
      },
      {
        title: 'Quản lý sàn',
        key: 'P41',
        childs: [
          { title: 'Thêm mới', key: 'P41.1' },
          { title: 'Chỉnh sửa', key: 'P41.2' },
          { title: 'Xóa sàn', key: 'P41.3' }
        ]
      },
      {
        title: 'Quản lý tài khoản',
        key: 'P42',
        childs: [
          { title: 'Thêm mới', key: 'P42.1' },
          { title: 'Chỉnh sửa', key: 'P42.2' },
          { title: 'Thay đổi mật khẩu', key: 'P42.3' },
          { title: 'Khóa tài khoản', key: 'P42.4' },
          { title: 'Thêm tiền tài khoản', key: 'P42.5' },
          { title: 'Xóa tài khoản', key: 'P42.6' },
          { title: 'Gia hạn cộng đồng', key: 'P42.7' }
        ]
      },
      {
        title: 'Quản lý thư viện dự án',
        key: 'P43',
        childs: [
          { title: 'Thêm mới', key: 'P43.1' },
          { title: 'Chỉnh sửa', key: 'P43.2' },
          { title: 'Xóa dự án', key: 'P43.3' },
          { title: 'Import', key: 'P43.4' }
        ]
      },
      {
        title: 'Quản lý dự án mở bán',
        key: 'P44',
        childs: [
          { title: 'Thêm mới', key: 'P44.1' },
          { title: 'Chỉnh sửa', key: 'P44.2' },
          { title: 'Xóa hàng dự án', key: 'P44.3' },
          { title: 'Import', key: 'P44.4' },
          { title: 'Danh sách nhận thông báo', key: 'P44.5' },
          { title: 'Danh sách xem nhà', key: 'P44.6' }
        ]
      },
      {
        title: 'Quản lý thông báo',
        key: 'P45',
        childs: [{ title: 'Thêm mới', key: 'P45.1' }]
      },
      {
        title: 'QL người dùng đấu giá và đăng ký xem nhà',
        key: 'P49',
        childs: [
          { title: 'Export', key: 'P49.1' },
          { title: 'Sửa', key: 'P49.2' },
          { title: 'Xoá', key: 'P49.3' },
          { title: 'Note', key: 'P49.4' }
        ]
      },
      {
        title: 'QL người dùng ĐK tư vấn thông tin dự án và ĐK xem căn hộ mẫu',
        key: 'P47',
        childs: [
          { title: 'Export', key: 'P47.1' },
          { title: 'Sửa', key: 'P47.2' },
          { title: 'Xoá', key: 'P47.3' },
          { title: 'Note', key: 'P47.4' }
        ]
      },
      {
        title: 'Quản lý cấu hình gói nạp tiền & khuyến mãi [App+Web]',
        key: 'P51',
        childs: [
          { title: 'Thêm mới', key: 'P48.1' },
          { title: 'Chỉnh sửa', key: 'P48.2' },
          { title: 'Xóa gói nạp tiền', key: 'P48.3' }
        ]
      },
      {
        title: 'QL nạp tiền & thanh toán',
        key: 'P52',
        childs: [{ title: 'Export', key: 'P52.1' }]
      },
      {
        title: 'QL cấu hình gói gia hạn cộng đồng',
        key: 'P53',
        childs: [
          { title: 'Thêm mới', key: 'P53.1' },
          { title: 'Chỉnh sửa', key: 'P53.2' },
          { title: 'Active/ Inactive', key: 'P53.3' }
        ]
      },
      {
        title: 'QL lịch sử gia hạn cộng đồng',
        key: 'P54',
        childs: [{ title: 'Export', key: 'P54.1' }]
      },
      {
        title: 'Quản lý cấu hình gói tin đăng [Web]',
        key: 'P55',
        childs: [
          { title: 'Thêm mới', key: 'P55.1' },
          { title: 'Chỉnh sửa', key: 'P55.2' },
          { title: 'Xem chi tiết', key: 'P55.3' },
          { title: 'Active/ Inactive', key: 'P55.4' }
        ]
      },
      {
        title: 'Quản lý lịch sử gói tin đăng [Web]',
        key: 'P56',
        childs: [{ title: 'Export', key: 'P56.1' }]
      },
      {
        title: 'Quản lý tin đăng trên [Web]',
        key: 'P57',
        childs: [
          { title: 'Chỉnh sửa', key: 'P57.1' },
          { title: 'Xoá', key: 'P57.2' },
          { title: 'Export', key: 'P57.3' }
        ]
      },
      {
        title: 'Quản lý đối soát qua Công thanh toán',
        key: 'P58',
        childs: [{ title: 'Export', key: 'P58.1' }]
      },
      {
        title: 'Quản lý footer',
        key: 'P59',
        childs: [
          { title: 'Thêm mới', key: 'P59.1' },
          { title: 'Xóa', key: 'P59.2' },
          { title: 'Xuống', key: 'P59.3' },
          { title: 'Lên', key: 'P59.4' }
        ]
      },
      {
        title: 'Quản lý số iMess',
        key: 'P60',
        childs: [
          { title: 'Thêm mới', key: 'P60.1' },
          { title: 'Chỉnh sửa', key: 'P60.2' },
          { title: 'Import', key: 'P60.3' },
          { title: 'Export', key: 'P60.4' },
          { title: 'Xóa', key: 'P60.5' }
        ]
      },
      {
        title: 'Quản lý up ảnh thông báo Nội bộ và Cộng đồng',
        key: 'P61',
        childs: [
          { title: 'Thêm mới', key: 'P61.1' },
          { title: 'Chỉnh sửa', key: 'P61.2' },
          { title: 'Xóa', key: 'P61.3' },
          { title: 'Tạo ảnh', key: 'P61.4' }
        ]
      },
      {
        title: 'Quản lý thông tin trung tâm',
        key: 'P62',
        childs: [
          { title: 'Thêm mới', key: 'P62.1' },
          { title: 'Chỉnh sửa', key: 'P62.2' },
          { title: 'Xóa', key: 'P62.3' }
        ]
      },
      {
        title: 'Quản lý trùng tin BĐS nội bộ',
        key: 'P76',
        childs: [
          { title: 'Xóa bên ngoài - Tin gốc', key: 'P76.1' },
          {
            title: 'Xóa trong List danh sách tin trùng - List bên trong ',
            key: 'P76.2'
          }
        ]
      },
      {
        title: 'Quản lý tin trùng app cộng đồng',
        key: 'P77',
        childs: [
          { title: 'Xóa bên ngoài - Tin gốc', key: 'P77.1' },
          {
            title: 'Xóa trong List danh sách tin trùng - List bên trong ',
            key: 'P77.2'
          }
        ]
      },
      {
        title: 'Quản lý tuyển dụng',
        key: 'P78',
        childs: [
          { title: 'Export', key: 'P78.1' },
          { title: 'Sửa', key: 'P78.2' },
          { title: 'Xoá', key: 'P78.3' },
          { title: 'Note', key: 'P78.4' }
        ]
      },
      {
        title: ' Quản lý tin nhanh',
        key: 'P79',
        childs: [
          { title: 'Export', key: 'P79.1' },
          { title: 'Sửa', key: 'P79.2' },
          { title: 'Xoá', key: 'P79.3' },
          { title: 'Note', key: 'P79.4' },
          { title: 'Xem lịch sử', key: 'P79.5' }
        ]
      },
      {
        title: 'Quản lý Selection List',
        key: 'P80',
        childs: [
          { title: 'Thêm mới selection', key: 'P80.1' },
          { title: 'Sửa selection', key: 'P80.2' },
          { title: 'Xoá selection', key: 'P80.3' },
          { title: 'Thêm mới category', key: 'P80.4' }
        ]
      },
      {
        title: 'Quản lý DATA danh sách khách hàng',
        key: 'P81',
        childs: [
          { title: 'Import Excel', key: 'P81.1' },
          { title: 'Sửa', key: 'P81.2' },
          { title: 'Xoá', key: 'P81.3' },
          { title: 'Note', key: 'P81.4' },
          { title: 'Export', key: 'P81.5' }
          // { title: 'Thêm mới category', key: 'P81.4' },
        ]
      },

      {
        title: 'Quản lý thu phí web',
        key: 'P82',
        childs: [
          { title: 'Thêm mới', key: 'P82.1' },
          { title: 'Sửa', key: 'P82.2' },
          { title: 'Xoá', key: 'P82.3' }
        ]
      },
      {
        title: 'Quản lý dịch vụ',
        key: 'P83',
        childs: [
          { title: 'Thêm mới', key: 'P83.1' },
          { title: 'Sửa', key: 'P83.2' },
          { title: 'Xoá', key: 'P83.3' }
        ]
      },
      {
        title: 'Quản lý tài khoản web',
        key: 'P84',
        childs: [
          { title: 'Chỉnh sửa', key: 'P84.1' },
          { title: 'Thay đổi mật khẩu', key: 'P84.2' },
          { title: 'Khóa tài khoản', key: 'P84.3' },
          { title: 'Thêm tiền tài khoản', key: 'P84.4' },
          { title: 'Xóa tài khoản', key: 'P84.5' }
        ]
      },
      {
        title: 'Quản lý yêu cầu trên web',
        key: 'P85',
        childs: [
          { title: 'Sửa yêu cầu', key: 'P83.1' },
          { title: 'Xóa yêu cầu', key: 'P83.2' },
          { title: 'Mô tả', key: 'P83.3' },
          { title: 'xoá', key: 'P83.4' },
          { title: 'Export', key: 'P83.5' }
        ]
      },
      {
        title: 'Quản lý booking',
        key: 'P86',
        childs: [
          { title: 'Cập nhật hiện trạng', key: 'P86.1' },
          { title: 'Note', key: 'P86.2' }
        ]
      }
    ]
  }
}
